'use strict';
// TODO: DELETE THAT DIRECTIVE, USE SWIPER API
/**
 *
 * @name: horizontalScroll
 *
 */

/* jslint evil: true*/

function HorizontalScrollDirective($location, $rootScope, $timeout, $state) {

  'ngInject';

  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      setTimeout(function () {
        bindNav();
      }, 300);

      var leftScrollClickWatch;
      var leftScrollDisable;

      function bindNav() {

        var bookmarkList = false;

        if (attrs.bookmarkList) {
          bookmarkList = true;
        }

        var extWrap = element.find('.ext-wrap');
        var extWrapChild = element.find('.ext-wrap > *');
        var next = element.find('.nav .next');
        var prev = element.find('.nav .prev');

        // Arrows visibility
        scope.nextVisibility = false;
        scope.prevVisibility = false;

        var breakpoints = parseInt(attrs.breakpoints);
        var breakpoint1 = parseInt(attrs.breakpoint1);
        var loadMoreInterval = parseInt(attrs.loadMoreInterval);
        var loadMoreFunction = attrs.loadMoreFunction || 'loadMore';
        var loadMoreFunctionLeft = attrs.loadMoreFunctionLeft || null;
        var swipeLeftFunction = attrs.swipeLeftFunction || 'swipeLeft';
        var swipeRightFunction = attrs.swipeRightFunction || 'swipeRight';
        var firstMargin = parseInt(attrs.firstMargin) || null;
        var noMargins = Boolean(attrs.noMargins);
        var breakpoint2 = breakpoints > 1 ? parseInt(attrs.breakpoint2) : null;
        var collection = attrs.collection;
        var offsetScroll = null;
        scope.countScroll = 0;
        var countLoadMore = 0;
        prev.addClass('hidden');

        // THIS IS CORRECT HANDLING OF INITIAL COUNTLOADMORE

        var IS_PICKS = $location.path().match('/picks/');
        var IS_CATEGORY_STORY = ($state.current.name === 'main.category' && typeof $state.params.postSlug !== 'undefined' && $state.params.postSlug !== null);

        if (IS_CATEGORY_STORY) {

          var items = element.find('article.js-story-block');
          var countScroll = 0;

          items.each(function (index) {

            var el = $(this);

            if (el.hasClass('is-now-playing')) {

              countScroll = parseInt(index) - 1;
            }
          });

          scope.countScroll = countScroll;
          prev.removeClass('hidden');
        }
        if (IS_PICKS) {

          var processListForPrev = function () {

            for (var i = 0; i < scope.list.length; i++) {

              if (scope.list[i].id === scope.post.id) {

                if (i > 2) {
                  prev.removeClass('hidden');
                }

                scope.countScroll = i < 2 ? 0 : i - 1;
                break;
              }
            }
          };

          if (scope.list && scope.list.length) {

            processListForPrev();
          } else {

            var scopeListLengthWatch = scope.$watch('list.length', function (newVal) {

              if (newVal) {

                scopeListLengthWatch();
                processListForPrev();
              }
            });
          }
        }

        setTimeout(function () {

          scope.onlyCurrentExtWrapChildWidth = function () {

            return extWrapChild.width();
          };

          if (collection) {

            var stringer = 'scope.' + eval('collection');

            try {

              scope.elementsCount = eval(stringer).length;
            } catch (e) {

            }
          }

          scope.$watch(collection + '.length', function (newVal) {

            if (newVal || newVal === 0) {

              scope.elementsCount = newVal;
            }
          });

          scope.$watch('onlyCurrentExtWrapChildWidth()', function () {

            // If not enough elements
            if (extWrap.width() > extWrapChild.width()) {
              next.addClass('hidden');
              prev.addClass('hidden');
            } else {
              next.removeClass('hidden');
            }
          });

          scope.prevoffset = 0;

          function getOffset() {

            if ($rootScope.bWidth <= breakpoint1) {

              offsetScroll = parseInt(attrs.offsetScroll1);
            } else {

              if (breakpoints > 1 && $rootScope.bWidth > breakpoint2) {

                firstMargin = 0;
                offsetScroll = parseInt(attrs.offsetScroll3);
              } else if (breakpoints > 1) {

                offsetScroll = parseInt(attrs.offsetScroll2);
              } else {
                firstMargin = 0;

                offsetScroll = parseInt(attrs.offsetScroll2);
              }
            }
          }

          var nextClick = function () {

            getOffset();

            var margins = (extWrap.width() - offsetScroll) / 2;

            if (margins > offsetScroll || noMargins) {
              margins = 0;
            }

            if (!scope.scrollOn && scope.countScroll < scope.elementsCount - 1) {

              scope.scrollOn = true;

              var postAnim = function () {
                if (loadMoreInterval && scope.countScroll % loadMoreInterval === 0 && scope.countScroll / loadMoreInterval >= countLoadMore) {

                  if (scope[loadMoreFunction]) {

                    scope[loadMoreFunction]();
                  }

                  countLoadMore++;
                }

                if (extWrap.scrollLeft() + extWrap.width() > extWrapChild.width() - 100) {

                  next.addClass('hidden');
                } else {

                  scope.prevoffset = extWrap.scrollLeft();
                  scope.countScroll++;
                }

                if (extWrap.scrollLeft()) {
                  prev.removeClass('hidden');
                }
              };

              extWrap.stop().animate({
                scrollLeft: (scope.countScroll + 1) * offsetScroll + firstMargin - margins
              }, 333, 'swing', function () {

                scope.scrollOn = false;

                if (scope.countScroll === scope.elementsCount - 2) {

                  next.addClass('hidden');
                }

                postAnim();
              });

            }
          };

          var prevClick = function () {

            getOffset();
            var currScrollLeft;
            var margins = (extWrap.width() - offsetScroll) / 2;

            if (margins > offsetScroll || noMargins) {

              margins = 0;
            }

            currScrollLeft = extWrap.scrollLeft();

            if (extWrap.scrollLeft() > 0 && scope.countScroll === 0) {

              scope.countScroll = 1;

              if (loadMoreLeftProcess) {

                loadMoreLeftProcess(currScrollLeft);
              }
            }

            if ((!scope.scrollOn && scope.countScroll > 0) || $location.path().match('/picks/')) {

              scope.scrollOn = true;

              if (scope.countScroll === 1) {

                extWrap.stop().animate({
                  scrollLeft: 0 + firstMargin - margins
                }, 333, 'swing', function () {

                  scope.scrollOn = false;
                  prev.addClass('hidden');
                  loadMoreLeftProcess(currScrollLeft);
                });
              } else {

                extWrap.stop().animate({
                  scrollLeft: (scope.countScroll - 1) * offsetScroll + firstMargin - margins
                }, 333, 'swing', function () {

                  scope.scrollOn = false;
                  loadMoreLeftProcess(currScrollLeft);
                });
              }

              next.removeClass('hidden');
              scope.countScroll--;
            }

            // solely for left-side infinite scroll

            function loadMoreLeftProcess(currScrollLeft) {

              if (leftScrollDisable) {

                return;
              }

              leftScrollDisable = true;
              var inUse = {
                offsetChange: null
              };

              if (loadMoreFunctionLeft && scope[loadMoreFunctionLeft]) {

                scope.common.justAddingNewPosts = true;

                if (leftScrollClickWatch) {

                  leftScrollClickWatch();
                }

                leftScrollClickWatch = scope.$watch('list.length', function (newVal, oldVal) {

                  if (newVal && newVal > oldVal) {

                    leftScrollClickWatch();
                    extWrap.scrollLeft(currScrollLeft + ((inUse.offsetChange - 1) * offsetScroll));
                  }
                });

                scope[loadMoreFunctionLeft]().then(function (offsetChange) {

                  if (offsetChange) {

                    inUse.offsetChange = offsetChange;
                    scope.countScroll = scope.countScroll + offsetChange;
                    extWrap.stop();
                  } else {

                    leftScrollClickWatch();
                    scope.common.justAddingNewPosts = false;
                  }

                  leftScrollDisable = false;
                });
              }
            }

          };

          scope[swipeLeftFunction] = function () {

            $rootScope.ucpPreventSwipe = true;

            $timeout(function () {

              $rootScope.ucpPreventSwipe = false;
            }, 50);
            nextClick();
          };

          scope[swipeRightFunction] = function () {

            $rootScope.ucpPreventSwipe = true;
            $timeout(function () {

              $rootScope.ucpPreventSwipe = false;
            }, 50);
            prevClick();
          };

          next.click(nextClick);
          prev.click(prevClick);
        }, 150);
      }
    }
  };
}

export default HorizontalScrollDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-horizontal-scroll.directive.js